import { BaseService } from './baseservice';

class ApiReportsClass extends BaseService {

    async getUsers(orgId) {
        const response = await this.fetch('GET', `/v2/org/${orgId}/list`);

        return (response && response.data) ? response.data : [];
    }

    async getEmails() {
        const response = await this.fetch('GET', '/v2/emails');

        return (response && response) ? response.data.data : '';
    }

    async updateEmails(body) {
        const response = await this.fetch('PUT', '/v2/emails', body);

        return (response && response.data) ? response.data : '';
    }

    async isAllowed() {
        const response = await this.fetch('GET', '/v2/allowed');

        return (response && response.data) ? response.data : response.error;
    }

    async getKeyData(keyId) {
        const response = await this.fetch('GET', `/v2/keys/${keyId}`);

        return (response && response.data) ? response.data : response.error;
    }

    async changeStatus(keyId, body) {
        const response = await this.fetch('PUT', `/v2/keys/${keyId}`, body);

        return (response && response.data) ? response.data : response.error;
    }

    async generateKey(keyId) {
        const response = await this.fetch('PUT', `/v2/keys/${keyId}/generate`);

        return (response && response.data) ? response.data : response.error;
    }

    async saveExternalUser(user) {
        const response = await this.fetch('POST', `/v2/keys/${keyId}/generate`);

        return (response && response.data) ? response.data : response.error;
    }

    async getUserKey() {
        const response = await this.fetch('get', `/v2/key`);

        return (response && response.data) ? response.data : response.error;
    }
}

let ApiReportsService = new ApiReportsClass();
export default ApiReportsService;
